import React, { useState, useEffect } from 'react'
import { toast } from 'react-hot-toast'

// 简化版通知管理组件
const NotificationsManagement: React.FC = () => {
  const [notifications, setNotifications] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // 模拟加载通知数据
    const mockNotifications = [
      {
        id: 1,
        title: '系统维护通知',
        content: '系统将于今晚进行维护',
        type: 'system',
        status: 'sent',
        created_at: '2025-01-13T10:00:00Z'
      },
      {
        id: 2,
        title: '新功能上线',
        content: '课程管理功能已上线',
        type: 'feature',
        status: 'draft',
        created_at: '2025-01-13T09:00:00Z'
      }
    ]
    setNotifications(mockNotifications)
  }, [])

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">通知管理</h1>
        <p className="text-gray-600">管理系统通知和消息推送</p>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-medium">通知列表</h2>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              创建通知
            </button>
          </div>
        </div>

        <div className="p-4">
          {loading ? (
            <div className="text-center py-8">加载中...</div>
          ) : notifications.length === 0 ? (
            <div className="text-center py-8 text-gray-500">暂无通知</div>
          ) : (
            <div className="space-y-4">
              {notifications.map((notification) => (
                <div key={notification.id} className="border rounded-lg p-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="font-medium text-gray-900">{notification.title}</h3>
                      <p className="text-gray-600 text-sm mt-1">{notification.content}</p>
                      <div className="flex items-center space-x-4 mt-2 text-sm text-gray-500">
                        <span>类型: {notification.type}</span>
                        <span>状态: {notification.status}</span>
                        <span>创建时间: {new Date(notification.created_at).toLocaleString()}</span>
                      </div>
                    </div>
                    <div className="flex space-x-2">
                      <button className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200">
                        编辑
                      </button>
                      <button className="px-3 py-1 text-sm bg-red-100 text-red-700 rounded hover:bg-red-200">
                        删除
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { NotificationsManagement }
export default NotificationsManagement